import React, { useContext } from 'react';
import QuestionGroupContext from '../../../contexts/QuestionGroupContext';
import InspectionQuestion from './InspectionQuestion';

/** The ordered question rows of a FORM / TABLE group. */
const InspectionQuestions: React.FC = () => {
  const { questionGroup } = useContext(QuestionGroupContext);

  const questions = [...questionGroup.questions].sort(
    (a, b) => a.sort_order - b.sort_order,
  );

  return (
    <div className='utb-questions'>
      {questions.map((question, index) => (
        <InspectionQuestion
          key={question.id}
          question={question}
          index={index}
          count={questions.length}
        />
      ))}
      {questions.length === 0 && (
        <div className='utb-questions__empty'>No questions yet</div>
      )}
    </div>
  );
};

export default InspectionQuestions;
